"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var arAa = require("./ar_aa.json");
var bnBd = require("./bn_bd.json");
var bnIn = require("./bn_in.json");
var daDk = require("./da_dk.json");
var deDe = require("./de_de.json");
var elGr = require("./el_gr.json");
var enGb = require("./en_gb.json");
var enUs = require("./en_us.json");
var esAr = require("./es_ar.json");
var esEs = require("./es_es.json");
var esMx = require("./es_mx.json");
var es = require("./es.json");
var fiFi = require("./fi_fi.json");
var filPh = require("./fil_ph.json");
var frFr = require("./fr_fr.json");
var guIn = require("./gu_in.json");
var hiIn = require("./hi_in.json");
var idId = require("./id_id.json");
var itIt = require("./it_it.json");
var jaJp = require("./ja_jp.json");
var knIn = require("./kn_in.json");
var koKr = require("./ko_kr.json");
var mlIn = require("./ml_in.json");
var mrIn = require("./mr_in.json");
var msMy = require("./ms_my.json");
var nbNo = require("./nb_no.json");
var nlNl = require("./nl_nl.json");
var paIn = require("./pa_in.json");
var plPl = require("./pl_pl.json");
var ptBr = require("./pt_br.json");
var ptPt = require("./pt_pt.json");
var roRo = require("./ro_ro.json");
var ruRu = require("./ru_ru.json");
var svSe = require("./sv_se.json");
var taIn = require("./ta_in.json");
var teIn = require("./te_in.json");
var thTh = require("./th_th.json");
var trTr = require("./tr_tr.json");
var urPk = require("./ur_pk.json");
var viVn = require("./vi_vn.json");
var zhCn = require("./zh_cn.json");
var zhTw = require("./zh_tw.json");
var content = {
    'ar-aa': arAa,
    'bn-bd': bnBd,
    'bn-in': bnIn,
    'da-dk': daDk,
    'de-de': deDe,
    'el-gr': elGr,
    'en-gb': enGb,
    'en-us': enUs,
    'es-ar': esAr,
    'es-es': esEs,
    'es-mx': esMx,
    'es': es,
    'fi-fi': fiFi,
    'fil-ph': filPh,
    'fr-fr': frFr,
    'gu-in': guIn,
    'hi-in': hiIn,
    'id-id': idId,
    'it-it': itIt,
    'ja-jp': jaJp,
    'kn-in': knIn,
    'ko-kr': koKr,
    'ml-in': mlIn,
    'mr-in': mrIn,
    'ms-my': msMy,
    'nb-no': nbNo,
    'nl-nl': nlNl,
    'pa-in': paIn,
    'pl-pl': plPl,
    'pt-br': ptBr,
    'pt-pt': ptPt,
    'ro-ro': roRo,
    'ru-ru': ruRu,
    'sv-se': svSe,
    'ta-in': taIn,
    'te-in': teIn,
    'th-th': thTh,
    'tr-tr': trTr,
    'ur-pk': urPk,
    'vi-vn': viVn,
    'zh-cn': zhCn,
    'zh-tw': zhTw,
};
exports.default = content;
//# sourceMappingURL=index.js.map